import './AreaList.css'
import Button from '/src/components/UI/Button/Button';
import { useRef, useEffect, useCallback } from 'react';


// This component is made to be use in any Form component of the bot editor
function AreaList({title, children, className, maxHeight, buttonLabel , onClickButton, unfold, setUnfold, buttonDisabled}) {

    const aeraListContainer = useRef();
    
    //style={{ height : unfold ? parseInt(maxHeight,10) + 50 : 0 }}

    // We need to set an observer to check each time our parent components is resized, but we need to put it in a use effect
    // In fact if we unmount the component, we need to disconnect the observer or tha will leak to some bug
    // We can only do that with a useEffect, moreover we don't want this function to be call on every rerender
    // so we just pust the areaListContainer in dependies list, maybe tha function need to have her scope updated if the areaListContainerChange
    useEffect(() => {
        if(aeraListContainer.current == null) {
            return;
        }

        const resize = () => {
            if(aeraListContainer.current == undefined) {
                return;
            }
            return aeraListContainer.current.scrollHeight > parseInt(maxHeight,10) ? aeraListContainer.current.classList.add('scroll') : aeraListContainer.current.classList.remove('scroll')
        }
        var observer = new ResizeObserver(resize)
        observer.observe(aeraListContainer.current)
        return () => {
            observer.disconnect();
        }
    }, [aeraListContainer])


    const onClick = () => {
        console.log(aeraListContainer.current)
        const scroll = (duration) => scrollToBottom(aeraListContainer.current, duration);
        onClickButton([scroll]);
    }
    

    const scrollToBottom = (area, duration) => {
        if(area == null) {
            return;
        }

        setTimeout(() => {
            area.firstChild.firstChild.lastElementChild.scrollIntoView( { behavior: 'smooth' } )
        })
        
        //el.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest' })
    }

    className = className ? 'area-list ' + className : 'area-list';
    return (
        <div className="area-container"> 
            <div className={className} style={{ cursor : unfold ? 'default' : 'pointer'}} {...(unfold ? {} : {onClick : setUnfold})}>
                <div className='top-bar'>{title}</div>
                <div className={unfold  ? 'info-bar' : 'info-bar fold'} style={{ maxHeight : unfold ? parseInt(maxHeight,10) + 50 : 0 }}>
                    <div className='area-list-container' style={{ maxHeight }} ref={aeraListContainer}>{children}</div>
                    <div className="button-container-center">
                        {buttonLabel && <Button label={buttonLabel} onClick={onClick} disabled={buttonDisabled}/>}
                    </div> 
                </div>
            </div>
        </div>
    )
}

AreaList.defaultProps = {
    maxHeight : 70,
    unfold : true,
    setUnfold : () => {},
    onClickButton : () => {},
    buttonDisabled : false,
}

export default AreaList;